import { Component, OnInit, Output, EventEmitter, ElementRef, HostListener, AfterViewInit, ViewChild, Renderer2, ChangeDetectorRef, QueryList, ViewChildren, NgModule, enableProdMode, Input, SimpleChanges, OnChanges } from '@angular/core';

import { DxDropDownBoxModule, DxTreeViewModule, DxTreeViewComponent, DxSelectBoxComponent } from 'devextreme-angular';

import { FormGroup, FormControl, Validators, FormBuilder, AbstractControl } from '@angular/forms';
import { MapInformationService } from 'src/app/services/map-information.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { ProjectService } from 'src/app/services/project.service';
import { LoadingService } from 'src/app/services/loading.service';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { ToastService } from 'ng-uikit-pro-standard';
import DataGrid from "devextreme/ui/data_grid";
import { Key } from 'selenium-webdriver';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';

type AOA = any[][];
declare var $: any;

@Component({
  selector: 'app-schedule-values',
  templateUrl: './schedule-values.component.html',
  styleUrls: ['./schedule-values.component.scss']
})
export class ScheduleValuesComponent implements OnInit, OnChanges {
  @ViewChild(DxTreeViewComponent, { static: false }) treeView;
  @ViewChild('ScheduleGrid', {static: false}) ScheduleGrid: DxDataGridComponent;
  @ViewChild('ScheduleGrid1', {static: false}) ScheduleGrid1: DxDataGridComponent;
  @Input() parentProjectId: number;
  @Input() VieneDe: any;
  @Input() serviceID: any;
  // @ViewChild("gridfile", { static: false })
  @ViewChild("newPartSelect", { static: false }) newPartSelect: DxSelectBoxComponent;
  @ViewChild("gridfile", { static: false }) gridfile: DxDataGridComponent;
  @ViewChild('fileUploader', { static: false }) fileUploader: DxDataGridComponent;
  @ViewChild('gridObjectInformation', { static: false }) gridObjectInformation: DxDataGridComponent;
  // gridfile: DxDataGridComponent;

  public dataSchedule;

  @Input('infoschedule')
  set infoschedule(infoschedule: any) {
    this.dataSchedule = infoschedule;
  }
  @Output() onsubmit = new EventEmitter<any>();


  formSchedule: FormGroup;
  billingcategory: any = [];
  partsProduct: any;
  settings: any = {};
  deleteSelectedId: any;
  billingCategorySelected: any;
  partDetails: any;
  formatCurrency: any;
  taxes: any;
  taxSelected: any;
  auto: any;

  //Popups
  popupAddItem = false;
  showpopupRequestMaterials = false;
  cancelButton: any;
  saveNewButton: any;
  saveButton: any;
  showpopupDeleteItem: boolean = false;
  popupEditMultiple: boolean = false;
  disableEditMultiple = true;
  rowSelectedMultiple = [];
  saveButtonEditMultiple: any;
  cancelButtonEditMultiple: any;
  product = ''
  taxamountValue:any;
  taxFactor:any
  taxFactorTemporal:any
  taxTrue:boolean=false
  disabledTaxt:boolean = true
  importFrom:any[]=[
    {
      name:"Estimate",
      id:0
    },
    {
      name:"Spread Sheet",
      id:1
    }
  ]

  openPopupEstimated:boolean=false
  estimate:any[]=[]
  scheduleOfValuesDatasource = [];
  idEstimate:any=""
  ImporFrom:any=""
  seletedRowEdit = false;
  popupImportFromExcel:boolean=false
  openFullScreen:boolean=false

  valueDocument: any[] = [];


  constructor(
    private route: Router,
    private toast: ToastService,
    private appconfig: AppConfigService,
    private loadingService: LoadingService,
    private projectService: ProjectService,
    public MapInformationService:MapInformationService,
  ) {
    this.settings.dateFormat = this.appconfig.dateFormat;
    this.settings.moneyFormat = this.appconfig.moneyFormat;
    let moneyTableFormat = this.settings.moneyFormat;
    if(this.appconfig.moneyFormat=='$'){ moneyTableFormat = 'USD' }

    this.formatCurrency = {style: 'currency', currency: moneyTableFormat}
  }

  ngOnInit() {
    this.cancelButton = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupAddItem = false;
        this.partsProduct = []
        this.newPartSelect.placeholder = "Select"
      },
    };

    this.saveButton = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.saveNewItem();
      },
    };

    // this.getBillingCategory();
    this.projectService.GetTaxes().subscribe(result=>{
      console.log(result)
      let dataTaxes=[]
      if(result.length > 0){
        result.forEach(element => {
          if(element.TAX != undefined){
            dataTaxes.push(element)
          }
        });
      }
      this.taxes = dataTaxes;
    })
    console.log('Schedule Values',this.dataSchedule)
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('AAAAAAAAAAAAAAAAAAAAA ',changes)
    if(changes.VieneDe.firstChange==false){
      this.ngOnInit()
    }

    if(changes.parentProjectId != undefined){
      if(changes.parentProjectId.currentValue != undefined){
        this.projectService.GetBillingSchedule(changes.parentProjectId.currentValue).subscribe(result=>{
          this.dataSchedule = result.map((val, id)=>{
            val.TAX == true ? val.TAXCHECK = true : val.TAXCHECK = false;
            val.SHOWINBILL == true ? val.SHOWINBILLCHECK = true : val.SHOWINBILLCHECK = false ;
            if(val.DESCRIPTION != undefined){
              val.DESCRIPTION = val.DESCRIPTION.replace(/<[^>]+>/g, '')
            }
            val.number != undefined ? val.number = val.number.toFixed(2)  : '' ;
            if(val.QTY != undefined && val.PRODUCTSLSPRICE != undefined){
              val.ValTotalPrice = val.QTY * val.PRODUCTSLSPRICE
              val.ValTotalPrice.toFixed(2)
            }
            return val;
          })
        })
      }
    }
  }

  mdAddItem() {
    this.initForm();
    this.getAllParts();
    this.getBillingCategory();
    this.popupAddItem = true;
  }

  getBillingCategory(){
    if(this.billingcategory.length==0){
      this.projectService.GetBillingCategorys().subscribe(result=>{
        this.billingcategory = result;
      })
    }
  }

  getAllParts(){
    let mythis = this;

    this.partsProduct = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        if(loadOptions.searchValue == undefined || loadOptions.searchValue == ""){
          loadOptions.searchValue = " "
        }  else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.projectService.GetAllParts(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }



  updateParts(e){

    if(e.selectedItem!==null && e.selectedItem!==undefined){
      this.formSchedule.get('partnumber').setValue(e.selectedItem.ID);
      this.projectService.GetProjectPartDetail2(e.selectedItem.ID,this.parentProjectId).subscribe(result=>{
        console.log(result)
        this.formSchedule.get('description').setValue(result[0].PartDescription);
        this.formSchedule.get('costammount').setValue(result[0].PartCost);
        this.formSchedule.get('productslsprice').setValue(result[0].ProductPrice);
        this.formSchedule.get('productnumber').setValue(result[0].ProductNumber);

        // result[0].Tax_Factor = 0.07;

        const primero =  this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        const segundo =  Math.abs(primero) * Math.abs(result[0].Tax_Factor)

        const tercero =  this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        const cuarto =  Math.abs(segundo) - Math.abs(tercero)

        if(this.taxTrue){
          if(result[0].Tax_Factor == 0){
            this.taxamountValue = 0
            this.taxFactorTemporal = 0
            this.taxFactor = 0
          } else {
            this.taxFactorTemporal = result[0].Tax_Factor
          }
        } else {
          if(result[0].Tax_Factor == 0){
            this.taxamountValue = 0
            this.taxFactorTemporal = 0
            this.taxFactor = 0
            this.taxamountValue = undefined
            this.taxFactor = undefined
          } else {
            this.taxFactorTemporal = result[0].Tax_Factor
            this.taxamountValue = undefined
            this.taxFactor = undefined
          }
        }
        this.disabledTaxt=false
        this.changeBillingAmount();
      })
    }
  }

  setTax(data){
    // console.log(data)
    this.taxTrue = data.value
    if(data.value){
      const primero =  this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
      const segundo =  Math.abs(primero) * Math.abs(this.taxFactorTemporal)

      const tercero =  this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
      const cuarto =  Math.abs(segundo) - Math.abs(tercero)

      if(this.taxFactorTemporal == 0){
        this.taxamountValue = 0
        this.taxFactorTemporal = 0
        this.taxFactor = 0
      } else {
        this.taxamountValue = cuarto
        this.taxFactor = this.taxFactorTemporal
        let billing = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        let billingFinal = Math.abs(billing) + Math.abs(this.taxamountValue)
        this.formSchedule.get('billingamount').setValue(billingFinal);
      }
    } else {
      let billing = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
      this.formSchedule.get('billingamount').setValue(billing);
      this.taxamountValue = undefined
      this.taxFactor = undefined
    }
  }

  changeBillingAmount(){
    const primero =  this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
    const segundo =  Math.abs(primero * this.taxFactor)

    const tercero =  this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
    const cuarto =  Math.abs(segundo) - Math.abs(tercero)

    if(this.taxFactorTemporal == 0){
      this.taxamountValue = 0
      this.taxFactorTemporal = 0
      this.taxFactor = 0
    } else {
      this.taxamountValue = Math.abs(cuarto)
    }

    let billing = this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
    let billingFinal = Math.abs(billing) + Math.abs(this.taxamountValue)

    if(this.taxTrue){
      this.formSchedule.get('billingamount').setValue(billingFinal);
    } else {
      this.formSchedule.get('billingamount').setValue(billing);
      this.taxamountValue = undefined
      this.taxFactor = undefined
    }

  }

  //change color header grid
  onCellPrepared(e) {
    if (e.rowType === "header") {
      e.cellElement.style.backgroundColor = "rgb(242, 242, 242)";
      e.cellElement.style.color = "rgb(0, 0, 0)";
    }
  }

  duplicate(data){
    this.projectService.DuplicateBillingSchedule(data.ID).subscribe(result=>{
      this.toast.success('The Item has been duplicated successfully');
      this.onsubmit.emit();
    })
  }

  selectForDelete(data){
    this.showpopupDeleteItem = true;
    this.deleteSelectedId = data.ID;
  }

  deleteItem(id){
    this.projectService.DelteBillingSchedule(id).subscribe(result=>{
      this.toast.success('The Item has been duplicated successfully');
      this.showpopupDeleteItem = false;
      this.onsubmit.emit();
    })
  }

  selectionChanged(){
    console.log("aqui")
    this.rowSelectedMultiple = this.ScheduleGrid.instance.getSelectedRowsData();
    if(this.rowSelectedMultiple.length >=1){
      this.seletedRowEdit = true;
    }else{
      this.seletedRowEdit = false;
    }
  }

  // 01010101 01110111 01010101
  initForm(){
    this.formSchedule = new FormGroup({
      partnumber: new FormControl('', []),
      qty: new FormControl(1, []),
      description: new FormControl('', []),
      productdiscount: new FormControl(0, []),
      costammount: new FormControl(0, []),
      productslsprice: new FormControl(0, []),
      billingamount: new FormControl('', []),
      sort: new FormControl(0, []),
      area: new FormControl('', []),
      billingcategory: new FormControl('', []),
      tax: new FormControl('', []),
      showinbill: new FormControl('', []),
      overridenotes: new FormControl('', []),
      notes: new FormControl('', []),
      productnumber: new FormControl('', []),
      projectid: new FormControl(this.parentProjectId, []),
      id: new FormControl(0, [])
    });
    this.product = '';
  }

  saveNewItem(){
    let form = this.formSchedule.value;
    form.tax == true ? form.tax = 1 : form.tax = 0;
    form.showinbill == true ? form.showinbill = 1 : form.showinbill = 0;
    if(this.VieneDe == "editSWO"){
      form.serviceid = this.serviceID
    }
    console.log(form)
    this.projectService.InsertUpdateSchedule(form).subscribe(result=>{
      console.log(result)
      this.toast.success('The Quote information has been updated successfully.');
      this.popupAddItem = false;
      this.taxamountValue = 0
      this.taxFactor = 0
      this.newPartSelect.placeholder = "Select"
      this.partsProduct = []
      this.onsubmit.emit();
    })
  }

  edit(data){
    this.formSchedule = new FormGroup({
      partnumber: new FormControl(data.PARTNUMBER, []),
      qty: new FormControl(data.QTY, []),
      description: new FormControl(data.DESCRIPTION, []),
      productdiscount: new FormControl(data.PRODUCTDISCOUNT, []),
      costammount: new FormControl(data.COSTAMMOUNT, []),
      productslsprice: new FormControl(data.PRODUCTSLSPRICE, []),
      billingamount: new FormControl(data.BILLINGAMMOUN, []),
      sort: new FormControl(data.SORT, []),
      area: new FormControl(data.AREA, []),
      billingcategory: new FormControl(data.BILLINGCATEGORY, []),
      tax: new FormControl(data.TAX, []),
      showinbill: new FormControl(data.SHOWINBILL, []),
      overridenotes: new FormControl(data.OVERRIDENOTES, []),
      notes: new FormControl(data.NOTES, []),
      productnumber: new FormControl(data.PRODUCTNUMBER, []),
      projectid: new FormControl(this.parentProjectId, []),
      id: new FormControl(data.ID, [])
    });
    if(this.newPartSelect != undefined){
      this.newPartSelect.placeholder = data.DESCRIPTION
    }
    this.projectService.GetProjectPartDetail2(data.partnumber,this.parentProjectId).subscribe(result=>{
      this.disabledTaxt = false
      // result[0].Tax_Factor = 0.07;
      if(data.TAX){
        this.taxTrue = true

        const primero =  this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        const segundo =  Math.abs(primero) * Math.abs(result[0].Tax_Factor)

        const tercero =  this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        const cuarto =  Math.abs(segundo) - Math.abs(tercero)

        if(this.taxTrue){
          if(result[0].Tax_Factor == 0){
            this.taxamountValue = 0
            this.taxFactorTemporal = 0
            this.taxFactor = 0
          } else {
            this.taxFactorTemporal = result[0].Tax_Factor
            this.taxamountValue = cuarto
            this.taxFactor = result[0].Tax_Factor
          }
        } else {
          if(result[0].Tax_Factor == 0){
            this.taxamountValue = 0
            this.taxFactorTemporal = result[0].Tax_Factor
            this.taxFactor = 0
          } else {
            this.taxFactorTemporal = result[0].Tax_Factor
            this.taxamountValue = undefined
            this.taxFactor = undefined
          }
        }
        this.disabledTaxt=false
        this.changeBillingAmount();
      } else {
        this.taxTrue = false
        const primero =  this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        const segundo =  Math.abs(primero) * Math.abs(result[0].Tax_Factor)

        const tercero =  this.formSchedule.get('qty').value * this.formSchedule.get('productslsprice').value;
        const cuarto =  Math.abs(segundo) - Math.abs(tercero)

        if(result[0].Tax_Factor == 0){
          this.taxamountValue = 0
          this.taxFactorTemporal = 0
          this.taxFactor = 0
        } else {
          this.taxFactorTemporal = result[0].Tax_Factor
          this.taxamountValue = cuarto
          this.taxFactor = result[0].Tax_Factor
        }
        this.changeBillingAmount();
      }
    })
    // this.product = data.PARTNUMBER
    this.product = data.DESCRIPTION
    this.popupAddItem = true;
    this.getBillingCategory();
    this.getAllParts();
  }

  mdEditMultiple(){
    this.popupEditMultiple = true;
    this.rowSelectedMultiple = [];
    this.rowSelectedMultiple = this.ScheduleGrid.instance.getSelectedRowsData();
    console.log(this.rowSelectedMultiple)
    this.cancelButtonEditMultiple = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupEditMultiple = false;
      },
    };

    this.saveButtonEditMultiple = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.saveEditMultiple();
      },
    };
  }

  openModalDeleteMultiple:boolean=false

  mdDeleteMultiple(){
    this.openModalDeleteMultiple=true
  }

  DeleteMultiple(){
    let data = this.ScheduleGrid.instance.getSelectedRowsData();
    console.log(data)
    let contador = 0
    data.forEach(element=>{
      this.projectService.DelteBillingSchedule(element.ID).subscribe(result=>{
        contador++
        if (contador == data.length){
          this.toast.warning("Items were removed successfully")
          this.openModalDeleteMultiple=false
          this.onsubmit.emit();
        }
      })
    })

  }

  saveEditMultiple(){
    console.log(this.rowSelectedMultiple)

    let ids = '';
    this.rowSelectedMultiple.forEach((key,i)=>{
      if(key.OVERRIDENOTES != undefined){
        if(key.OVERRIDENOTES.length > 50){
          this.toast.warning("Override Notes can be max 50 characters long")
          return false
        }
      }
      ids = key.ID+','+ids;

      let valorFinal = 0
      let Calculartax = 0

      if(key.TAXCHECK){
        Calculartax = (key.QTY * key.PRODUCTSLSPRICE) * key.TaxPercent
        valorFinal = (key.QTY * key.PRODUCTSLSPRICE) + Calculartax
      }else{
        valorFinal = key.QTY * key.PRODUCTSLSPRICE
      }
      let saveRow = {
        id: key.ID,
        projectid: this.parentProjectId,
        notes: key.NOTES,
        partnumber: key.PARTNUMBER,
        productnumber: key.PRODUCTNUMBER,
        qty: key.QTY,
        description: key.DESCRIPTION,
        costammount: key.COSTAMMOUNT,
        productslsprice: key.PRODUCTSLSPRICE,
        billingamount: valorFinal,
        sort: key.SORT,
        area: key.AREA,
        billingcategory: key.BILLINGCATEGORY,
        tax: key.TAXCHECK,
        showinbill: key.SHOWINBILLCHECK,
        overridenotes: key.OVERRIDENOTES,
      }

        saveRow.tax == true ? saveRow.tax = 1 : saveRow.tax = 0;
        saveRow.showinbill == true ? saveRow.showinbill = 1 : saveRow.showinbill = 0;
        if(this.VieneDe == "editSWO"){
          let serviceid = {serviceid: this.serviceID}
          Object.assign(saveRow,serviceid);
        }
        console.log(saveRow);

        this.projectService.InsertUpdateSchedule(saveRow).subscribe(result=>{
          if(this.rowSelectedMultiple.length == i+1){
            // console.log('Guardado ',result);
            this.toast.success('The Quote information has been updated successfully.');
            this.onsubmit.emit();
            this.popupEditMultiple = false;
          }
        })
    })
  }

  // printReport(){
  //   this.route.navigate(['/reportviewer'], { queryParams: { reportname: "ProjectSOVandPart", reportparameters: "<projectid>"+this.parentProjectId+"</projectid>" } } );
  // }

  updateTaxes(){
    // console.log(this.taxSelected)
    this.projectService.UpdateProjectTax(this.parentProjectId, this.taxSelected).subscribe(result=>{
      // console.log(result);
      this.toast.success('The Tax has been updated successfully.');
      this.updateBillingSchedule()
    })
  }

  dataFormatted = { headers: [], data: [] };
  openPopupImport(data){
    console.log(data)
    if (data.value === 0){
      this.ImporFrom = 0
      this.openPopupEstimated = true
      const datos = {
        method:"Get_Projectestimate",
        projectid:this.parentProjectId
      }
      // console.log(datos)
      this.MapInformationService.SaveInfoSites(datos)
      .subscribe(resp=>{
        this.estimate = resp
        // console.log(resp)
      })
    } else if (data.value === 1){
      this.ImporFrom = 1
      this.popupImportFromExcel= true
    } else if (data.value === ""){
      this.ImporFrom = ""
      this.openPopupEstimated = false
      this.popupImportFromExcel = false
    }
  }

  CloseopenPopupImport(){
    // console.log("aqui")
    this.openPopupEstimated = false
    this.popupImportFromExcel = false
    this.idEstimate = ""
    this.scheduleOfValuesDatasource=[]
    this.ImporFrom = ""
    this.onFileRemove()
    this.valueDocument = []
  }


  searchEstimate(data){
    const datos = {
      'method': 'Get_EstimateScheduleOfValuesCE',
      'estimateid': data.value
    }
    this.idEstimate = data.value
    this.MapInformationService.SaveInfoSites(datos)
    .subscribe(resp=>{
      console.log(resp)
      let id = 0;
      this.scheduleOfValuesDatasource = resp.map(x => {
        id++;
        x.ident = id;

        return x;
      })
      // for (let i = 0; i < 30; i++) {
      //   this.scheduleOfValuesDatasource.push(this.scheduleOfValuesDatasource[0])
      // }
    })
  }


  importEstimate(){
    console.log("aqui")
    const data = {
      method:"Insert_CreateSOVfroestimateCE",
      estimateid:this.idEstimate
    }
    // console.log(data)
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      console.log(resp)
      this.CloseopenPopupImport()
      this.updateBillingSchedule()
    })
  }

  updateBillingSchedule(){
    this.projectService.GetBillingSchedule(this.parentProjectId).subscribe(result=>{
      this.dataSchedule = result.map((val, id)=>{
        val.TAX == true ? val.TAXCHECK = true : val.TAXCHECK = false;
        val.SHOWINBILL == true ? val.SHOWINBILLCHECK = true : val.SHOWINBILLCHECK = false ;
        if(val.DESCRIPTION != undefined){
          val.DESCRIPTION = val.DESCRIPTION.replace(/<[^>]+>/g, '')
        }
        val.number != undefined ? val.number = val.number.toFixed(2)  : '' ;
        if(val.QTY != undefined && val.PRODUCTSLSPRICE != undefined){
          val.ValTotalPrice = val.QTY * val.PRODUCTSLSPRICE
          val.ValTotalPrice.toFixed(2)
        }
        return val;
      })
      // console.log('Data Schedule Grid ',this.dataSchedule);
    })
  }

  onFileRemove() {
    this.dataFormatted = {
      headers: [],
      data: []
    }
    this.valueDocument = []
    // this.popupImportFromExcel = false
  }

  fileData: any[][] = [];
  onFileAdd(obj: File) {
    if(obj[0] != undefined){
      this.loadingService.isLoading.next(true);
      console.log('added', obj[0]);
      /* wire up file reader */
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        let data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
        data = data.filter(x => x.length > 0);
        this.fileData = data;
        this.dataFormatted.headers = data[0];
        console.log(JSON.stringify(data[0]))
        let dataFormateada = this.arrayToJSONObject(data);
        let infoFinal = []
        if(dataFormateada.length != 0){
          dataFormateada.forEach(element=>{
            if(element.Quantity != undefined){
              infoFinal.push(element)
            }
          })
          // this.dataFormatted.data = dataFormateada;
          this.dataFormatted.data = infoFinal;
          console.log(this.dataFormatted)
        }
        this.validateFile();
        // console.log('obj', this.dataFormatted.data.filter(x => !x.TAG && !x.QTY && !x.POINTTYPE && !x.POINTNUMBER && !x.PARTNUMBER && !x.APPNOTES));

        // console.log('obj', this.dataFormatted.data.filter(x =>  !x.TAG && !x.QTY && !x.POINTTYPE && !x.POINTNUMBER && !x.PARTNUMBER && !x.APPNOTES));
      };
      reader.readAsBinaryString(obj[0]);
      this.loadingService.isLoading.next(false);
    }
  }

  arrayToJSONObject(arr) {
    // header
    const keys = arr[0];

    // vacate keys from main array
    const newArr = arr.slice(1, arr.length);

    const formatted = [];
    const data = newArr;
    const cols = keys;
    const l = cols.length;
    for (let i = 0; i < data.length; i++) {
      const d = data[i];
      const o = {};
      for (let j = 0; j < l; j++) {
        o[cols[j]] = d[j];
      }
      formatted.push(o);
    }
    return formatted;
  }

  validateFile() {
    // this.dataFormatted.data.forEach(x => {
    //   this.estimateService.Get_EstimateAreaSystemDetailsImportCE(x.PARTNUMBER, x.APPNOTES, x.POINTTYPE).subscribe(result => {
    //     let obj = result[0];
    //     if (obj) {
    //       x.FlagApp_Note = obj.App_Note;
    //       x.FlagPart_Number = obj.Part_Number;
    //       x.FlagPoint_Type = obj.Point_Type;
    //     }
    //       console.log(result);
    //   });
    // });
  }

  uploadFile(){
    let data = this.gridfile.instance.getVisibleRows().map(x => x.data);
    let contador = 0
    let info
    let contadorTaxt = 0
    let contadorCostPrice = 0
    console.log(data)
    data.forEach(element=>{
      if (element.Taxable == 0 || element.Taxable == 1 || element.Taxable == "" || element.Taxable == undefined){
      } else {
        this.toast.warning("The Taxable field must be 1 for yes and 0 for no")
        contadorTaxt++
      }

      if(element.Cost === undefined || element.Cost === "" || element.Cost == null || element.Price === undefined || element.Price === "" || element.Price === null){

        console.log(element.Cost)
        console.log(element.Quantity)
        console.log(element.Price)
        this.toast.warning("The quantity, cost and price fields cannot be empty (you can put 0 instead)")
        contadorCostPrice++
      }
      if(isNaN(element.Quantity) == true || isNaN(element.Cost) == true || isNaN(element.Price) == true){
        this.toast.warning("The quantity, cost and price fields cannot have characters (you can put 0 instead)")
        contadorCostPrice++
      }
    })
    if(contadorTaxt == 0 && contadorCostPrice == 0){
      data.forEach(element=>{
        console.log(element)
        info = {
          partnumber:"",
          productnumber: "",
          qty: parseInt(element.Quantity),
          description: element.Billing_Description,
          costammount: parseInt(element.Cost),
          productslsprice: parseInt(element.Price),
          billingamount: parseInt(element.Quantity)*parseInt(element.Price),
          sort: element.Sort,
          area: element.Area,
          billingcategory: element.Category_ID,
          tax: element.Taxable == true ? 1:0,
          showinbill: 0,
          overridenotes: element.Override_Notes == undefined ? "":element.Override_Notes,
          notes: "",
          projectid:this.parentProjectId,
          id: 0,
          method:"Insert_ProjectPartDetailformSS",
          productmodel:element.Product_Number
        };
        if(this.VieneDe == "editSWO"){
          info.serviceid = this.serviceID
        }
        info.billingamount = info.billingamount.toFixed(2)
        this.MapInformationService.SaveInfoSites(info)
        .subscribe(resp=>{
          contador++
          if(contador == data.length){
            this.toast.success("information successfully uploaded")
            this.onFileRemove()
            this.CloseopenPopupImport()
            this.onsubmit.emit();
          }
        },error=>{
          console.log(error)
          this.toast.warning("An error has occurred check the header and structure of the excel")
        })
      })
    }
  }

  PrintReport(data){
    console.log(data)
    switch(data.itemData){
      case "Template I":
        this.route.navigate(['/reportviewer'], { queryParams: { reportname: "ProjectSOVandPart", reportparameters: "<projectid>"+this.parentProjectId+"</projectid>" } } );
      break
      case "Quote Form":
        console.log("aqui")
        this.route.navigate(['/reportviewer'], { queryParams: { reportname: "salesProject", reportparameters: "<projectid>"+this.parentProjectId+"</projectid>" } } );
      break
    }
  }

  updateBillingAmount(event){
    console.log(event)

    const primero =  this.formSchedule.get('qty').value * event.value;
    const segundo =  Math.abs(primero * this.taxFactor)

    const tercero =  this.formSchedule.get('qty').value * event.value;
    const cuarto =  Math.abs(segundo) - Math.abs(tercero)

    if(this.taxFactorTemporal == 0){
      this.taxamountValue = 0
      this.taxFactorTemporal = 0
      this.taxFactor = 0
    } else {
      this.taxamountValue = Math.abs(cuarto)
    }

    let billing = this.formSchedule.get('qty').value * event.value;
    let billingFinal = Math.abs(billing) + Math.abs(this.taxamountValue)

    if(this.taxTrue){
      this.formSchedule.get('billingamount').setValue(billingFinal);
    } else {
      this.formSchedule.get('billingamount').setValue(billing);
      this.taxamountValue = undefined
      this.taxFactor = undefined
    }
  }

  infoMaterial:any[]=[]
  showPopupMR:boolean=false
  openModalRequest(){
    this.MapInformationService.SaveInfoSites({method:"Get_ProjectsovByIdforMR",projectid:this.parentProjectId})
    .subscribe(resp=>{
      console.log(resp)
      this.showpopupRequestMaterials = true
      this.infoMaterial= resp
    })
  }

  saveRequestModal(){
    console.log("aqui")
    this.showPopupMR = true
  }

  saveRequest(){
    let data = this.gridObjectInformation.instance.getSelectedRowsData();
    if(data.length > 0){
      console.log(data)
      let dataFinal = ""
      data.forEach(info=>{
        if(dataFinal == ""){
          dataFinal = info.ID.toString()
        } else {
          dataFinal += ","+info.ID.toString()
        }
      })
      console.log(dataFinal)
      this.MapInformationService.SaveInfoSites({method:"Save_EditProjectMaterialRequest",projectid:this.parentProjectId,detailid:dataFinal})
      .subscribe(resp=>{
        this.toast.success("The Material Request information has been updated successfully")
        this.showpopupRequestMaterials = false
        this.showPopupMR = false
        this.updateBillingSchedule()
      })
    } else {
      this.toast.warning("You must select one or more records")
    }
  }
}
